// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","addressLineContainer":"address_addressLineContainer__XPW5G","defaultAddressContainer":"address_defaultAddressContainer__WopOh"};